import { render, staticRenderFns } from "./Propiedad.vue?vue&type=template&id=04bd33a0&"
import script from "./Propiedad.vue?vue&type=script&lang=js&"
export * from "./Propiedad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports